export default __webpack_public_path__ + "static/media/info-icon-blue.0c00dfdd.svg";